import { createFileRoute } from "@tanstack/react-router";
import { createFormData, useSimpleForm } from "@/hooks/use-simple-form";
import useAppStore from "@/store";
import { useTranslate } from "@/hooks/use-translate";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import ProductTest from "@/components/product/product-test";
import { ProductForm } from "@/components/product/product-form";
import { generateSKU, unPick } from "@/lib/utils";
import { addDays } from "date-fns";

export const Route = createFileRoute("/(dasboard)/products/products/create")({
  component: CreateProductPage,
});

function CreateProductPage() {
  const store = useAppStore();
  const { t, formatDate } = useTranslate();

  const form = useSimpleForm({
    name: "",
    sku: "",
    description: "",
    category_id: "",
    featured_image: {
      file: undefined,
      src: undefined,
    },
    images: [],
    //
    reorder_point: 0,
    minimum_stock_level: 1,
    maximum_stock_level: 1,
    valuation_method: "FIFO",
    selling_price: 0,
    unit_type_id: "",
  });

  useEffect(() => {
    if (store.auth.session) {
      store.category.fetch().then((categories) => {
        form.setValue("category_id", categories[0]?.id);
      });
      store.unitType.fetch().then((unitTypes) => {
        form.setValue("unit_type_id", unitTypes[0]?.id);
      });

      store.shop
        .getStats(
          "2025-01-01",
          formatDate(addDays(new Date(), 2), "yyyy-mm-dd"),
        )
        .then((stats) => {
          console.log(stats);
          form.setValue("sku", generateSKU());
        });
    }
  }, [store.auth.session]);

  const submit = async () => {
    store.errors.reset();
    const data = {
      ...unPick(form.values, ["featured_image"]),
      shop_id: store.auth.session?.currentShop?.id,
    };

    // Find the index of the featured image
    if (form.values.featured_image) {
      for (let i = 0; i < form.values.images.length; i++) {
        if (form.values.images[i].id == form.values.featured_image.id)
          data["featured_image_index"] = i;
      }
    }

    store.product
      .create(createFormData(data))
      .then(() => {
        store.product.fetch();
        window.history.back();
        form.reset();
      })
      .catch(store.errors.catch);
  };

  return (
    <section className="max-auto">
      {store.testing.canTest && <ProductTest form={form} submit={submit} />}
      <div className="mt-4 flex justify-between mb-4">
        <h2 className="text-xl font-semibold">{t("Add product")}</h2>
        <div>
          <Button
            onClick={submit}
            loading={store.product.loading("create")}
            className="py-2"
          >
            {t("Add product")}
          </Button>
        </div>
      </div>

      <div>{store.errors.render()}</div>

      {/* Use the ProductForm component with the initialized form */}
      <ProductForm mode="create" form={form} />

      <Button
        className="mt-8 px-6 py-3"
        onClick={submit}
        loading={store.product.loading("create")}
      >
        {t("Add product")}
      </Button>
    </section>
  );
}
